import { getGradientByValue } from "../../../Common/utils/statsUtil";
import {
  RadialBarChart,
  RadialBar,
  ResponsiveContainer,
  PolarAngleAxis,
  Legend,
} from "recharts";

const RadialChart = ({
  dataObj,
  chartProps,
  gradientArr = [],
  hasLegend = true,
  coreMap,
  gradientId = "",
}) => {
  let data = Object.entries(dataObj).map(([key, value]) => {
    return {
      value: value,
      name: coreMap[key].label,
      fill: coreMap[key].clrCode,
    };
  });
  const { name, value, fill } = data[0];
  const gradient = getGradientByValue(value, gradientArr);
  return (
    <div className="relative w-full h-full">
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart cx="50%" cy="50%" data={data} {...chartProps}>
          {gradientArr.length > 0 && (
            <defs>
              <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                {gradient.map((color, index) => (
                  <stop
                    key={index}
                    offset={`${(index / (gradient.length - 1)) * 100}%`}
                    stopColor={color}
                  />
                ))}
              </linearGradient>
            </defs>
          )}

          <PolarAngleAxis
            type="number"
            domain={[0, 100]}
            angleAxisId={0}
            tick={false}
            axisLine={false}
          />

          <RadialBar
            clockWise
            dataKey="value"
            cornerRadius={10}
            background={{ fill: "rgba(128, 166, 175, 0.1)" }}
            fill={
              gradientArr.length > 0 ? `url(#${gradientId})` : fill || "#00c8ff"
            }
          />

          {hasLegend && (
            <Legend
              content={({ payload }) => (
                <div className="pt-1 mb-1.5 translate-y-full text-primary text-sm font-normal text-center flex items-center justify-center text-nowrap">
                  {payload?.map((entry, index) => (
                    <div
                      key={`legend-${index}`}
                      className="flex items-center gap-1"
                    >
                      <span
                        className="inline-block w-1.5 h-1.5 rounded-full"
                        style={{ backgroundColor: entry.color }}
                      ></span>
                      <span>{entry.value}</span>
                    </div>
                  ))}
                </div>
              )}
            />
          )}
        </RadialBarChart>
      </ResponsiveContainer>

      <div className="absolute inset-0 flex items-center justify-center text-primary">
        <span className="text-14 font-medium">{value}</span>&nbsp;
        <span className="text-10 font-bold">%</span>
      </div>
    </div>
  );
};

export default RadialChart;
